// FCM 기기 토큰을 devices/{token} 에 등록한다. Expo Go 에서는 원격 푸시가 안 되므로(SDK 53+) 조용히 건너뛰고,
// 개발 빌드(expo run:android / EAS Build)에서만 실제 토큰이 잡힌다. iOS 는 Firebase 에 APNs 키가 있어야 한다.
import { Platform } from 'react-native';
import { hasFirebase, registerDevice } from './data';

export async function registerPush(onOpen: (dealId: string) => void): Promise<void> {
  if (!hasFirebase || Platform.OS === 'web') return;
  try {
    const Notifications = await import('expo-notifications');
    const Device = await import('expo-device');
    if (!Device.isDevice) return;
    Notifications.setNotificationHandler({
      handleNotification: async () => ({ shouldShowBanner: true, shouldShowList: true, shouldPlaySound: true, shouldSetBadge: false }),
    });
    Notifications.addNotificationResponseReceivedListener((r) => {
      const id = r.notification.request.content.data?.deal_id;
      if (typeof id === 'string') onOpen(id);
    });
    const { status } = await Notifications.requestPermissionsAsync();
    if (status !== 'granted') return;
    const token = (await Notifications.getDevicePushTokenAsync()).data;
    if (typeof token === 'string' && token) await registerDevice(token, Platform.OS);
  } catch (e) {
    console.log('푸시 등록 건너뜀 (Expo Go 이거나 권한 없음):', e instanceof Error ? e.message : e);
  }
}
